import React from 'react';
import { ClubPanel, PanelHead, MUTED, RULE, CHIP } from './clubUi';
import { priceLabel } from './clubViewerState';

/**
 * ABOUT (README §1): WHAT THIS CLUB IS · THE RITUAL (Times italic 22px) · admin-only
 * SETTINGS IN EFFECT with value pills (black for `ON…`, #F2F2F2 otherwise).
 *
 * SETTINGS IN EFFECT is for whoever runs the club, not for visitors: it reads the config back
 * (who may invite, whether the forum is on, whether the roster is exposed) and some rows tell a
 * stranger exactly what is being withheld. Gated on `canSeeSettings` (state.isAdmin — false while
 * an admin previews as a member).
 */
export function settingsRows(club, { forumCategoryCount = null } = {}) {
  const on = (v) => (v ? 'ON' : 'OFF');
  const rows = [
    ['Visibility', club.isPublic === false ? 'PRIVATE' : 'PUBLIC'],
    ['Who can invite', club.anyoneCanInvite ? 'ANY MEMBER' : 'ADMINS ONLY'],
    ['Member Portals', on(club.memberSignalsEnabled !== false)],
    ['Club forum', club.forumEnabled ? (forumCategoryCount != null ? `ON · ${forumCategoryCount} ${forumCategoryCount === 1 ? 'CATEGORY' : 'CATEGORIES'}` : 'ON') : 'OFF'],
    ['Members list', club.showMembersList === false ? 'ADMINS ONLY' : 'VISIBLE'],
    ['Gatherings', on(club.gatheringsEnabled !== false)],
    ['Membership', priceLabel(club)],
  ];
  if (club.maxMembers) rows.push(['Member cap', String(club.maxMembers)]);
  rows.push(['Approval', club.isPublic === false || club.requiresApproval ? 'ADMIN APPROVES' : 'INSTANT']);
  return rows;
}

export function AboutPanel({ club, phone = false }) {
  return (
    <ClubPanel phone={phone} data-testid="about-what">
      <PanelHead title="WHAT THIS CLUB IS" />
      <p className="m-0" style={{ fontSize: 14, lineHeight: 1.7, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', textWrap: 'pretty', color: club.description ? '#000' : MUTED }}>
        {club.description || club.tagline || 'The club has not written its description yet.'}
      </p>
    </ClubPanel>
  );
}

export function RitualPanel({ club, phone = false }) {
  if (!club.ritual) return null;
  return (
    <ClubPanel phone={phone} data-testid="about-ritual">
      <PanelHead title="THE RITUAL" />
      <p className="m-0" style={{ fontFamily: '"Times New Roman", Times, serif', fontStyle: 'italic', fontSize: phone ? 18 : 22, lineHeight: 1.4, textWrap: 'pretty' }}>{club.ritual}</p>
    </ClubPanel>
  );
}

export default function ClubAboutTab({ club, forumCategoryCount = null, mobile = false, canSeeSettings = false }) {
  const rows = settingsRows(club, { forumCategoryCount });
  return (
    <div className="flex flex-col font-mono" style={{ gap: mobile ? 10 : 16 }} data-testid="club-about">
      <AboutPanel club={club} phone={mobile} />
      <RitualPanel club={club} phone={mobile} />
      {canSeeSettings && (
        <ClubPanel phone={mobile} data-testid="about-settings">
          <PanelHead title="SETTINGS IN EFFECT" right="ADMINS SEE THIS" />
          <div className="flex flex-col">
            {rows.map(([k, v], i) => {
              const isOn = v === 'ON' || v.startsWith('ON ·');
              return (
                <span key={k} className="flex items-center justify-between" style={{ gap: 14, padding: '9px 0', borderTop: i ? RULE : 'none' }} data-testid={`setting-${k.replace(/\s+/g, '-').toLowerCase()}`}>
                  <span style={{ fontSize: 12, color: MUTED }}>{k}</span>
                  <span className="flex-none rounded-full uppercase" style={{ padding: '4px 10px', background: isOn ? '#000' : CHIP, color: isOn ? '#fff' : '#000', fontSize: 9, fontWeight: 800, letterSpacing: '.12em' }}>{v}</span>
                </span>
              );
            })}
          </div>
        </ClubPanel>
      )}
    </div>
  );
}
